const AGE_CLASSIFICATION_DISPLAY_LABEL_MAP: Record<string, string> = {
  "Menor de 12 años": "<12",
  "Entre 12 y 18 años": "12-17",
  "Mayor de 18 años": ">=18",
};
/**
 * Maps age classification names to shorter display labels for the UI
 */
export const getAgeClassificationDisplayLabel = (name: string): string => {
  return AGE_CLASSIFICATION_DISPLAY_LABEL_MAP[name] || name;
};
